enum InviteStatus {
    Queued = 0,
    Processing = 1,
    Successful = 2,
    Failed = 3
}

export default InviteStatus;